import { Component, Input, OnDestroy } from '@angular/core';
import { PaymentProcessService } from '../../../services/payment-process.service';
import { PaymentMethodRequest } from '../../../models/payment-method-request.interface';
import { PaymentMethodResponse } from '../../../models/payment-method-response.interface';
import { Subscription } from 'rxjs';
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
  selector: 'kt-payment-method-tab',
  templateUrl: './payment-method-tab.component.html',
  styleUrls: ['./payment-method-tab.component.scss'],
})
export class PaymentMethodTabComponent implements OnDestroy {
  @Input() organization: string;
  @Input() customerId: string; // contact uuid
  selectedIndex = 1;
  enableWalletModule = true;
  private subscription: Subscription[] = [];
  tabs = [];

  constructor(
    private processPaymentService: PaymentProcessService,
    private ngxPermissions: NgxPermissionsService,
  ) {
    if (this.canSelectFromWallet()) this.tabs.push('Wallet');
    if (this.canUseCreditCards()) this.tabs.push('Credit Card');
    if (this.canUseACHBankTransfer()) this.tabs.push('ACH Transfer');
  }

  ngOnDestroy() {
    if (this.subscription.length > 0) {
      this.subscription.forEach((s) => s.unsubscribe());
    }
  }

  canSelectFromWallet(): boolean {
    return !!this.ngxPermissions.getPermission('canSelectFromWallet');
  }

  canUseCreditCards(): boolean {
    return !!this.ngxPermissions.getPermission('canUseCreditCards');
  }

  canUseACHBankTransfer(): boolean {
    return !!this.ngxPermissions.getPermission('canUseACHBankTransfer');
  }

  onPaymentAdded(event: any) {
    const paymentMethodRequest: PaymentMethodRequest = {
      type: event.type,
      token_id: event.token.id,
      token_data: event.token,
      zip: event.zip,
      brand: event.brand,
      save_payment_method: event.savePaymentMethod,
      card_last4: event.cardLast4,
      alias: event.alias,
    };

    this.processPaymentService.updateField('payment_method', paymentMethodRequest);
  }

  onMethodChosen(method: PaymentMethodResponse): void {
    const paymentMethodRequest = {
      type: method.type,
      token_id: method.token_id,
      token_data: method.token_data?.data,
      zip: method?.token_data?.data?.data?.zip,
      brand: method?.token_data?.data?.card?.brand,
      card_last4:
        method?.token_data?.data?.card?.last4 ||
        method?.token_data?.data?.bank?.account_number_last4,
    };
    this.processPaymentService.updateField('payment_method', paymentMethodRequest);
  }
}
